import React from 'react';
import { AlertCommentType } from './types/AlertCommentType';
import AlertSystemComment
  from '../components/alerts/AlertDetailsPage/AlertDetailsNavTabs/AlertCommentsTabContent/AlertSystemComment/AlertSystemComment';

const getCommentBody = (text, type) => {
  let body = text;
  if (type === AlertCommentType.ROOM_ALERT) {
    body = (<AlertSystemComment text={text} />);
  }
  if (type === AlertCommentType.DELETED) {
    body = (<div className="mb-1 text-muted">This message has been deleted.</div>);
  }
  return body;
};

const getCommenterName = (firstName, lastName, type) => {
  let commenterName = `${firstName || ''} ${lastName || ''}`;
  if (type === AlertCommentType.ROOM_ALERT) {
    commenterName = 'Room Alert';
  }
  return commenterName;
};

export {
  getCommentBody,
  getCommenterName,
};
